import React from 'react';
import Icon from '../Common/Icon';

export default class Forms extends React.Component {

    changeMe(event) {
        event.preventDefault();
    }

    render() {
        return (
            <div className="guide-page">
                <h3 className="guide-title">Icons</h3>
                <p className="guide-lead">Below you will find the specific icons we are using from the following library: <a href="https://fontawesome.com/v4.7.0/">https://fontawesome.com/v4.7.0/</a></p>

                <div className="component">
                    <legend>Icon component</legend>
                    <p>You can put them in bootstrap components...&nbsp;<button className="btn btn-outline-primary"><Icon name="thumbs-up" /></button>&nbsp;<button className="btn btn-primary"><Icon name="thumbs-up" /><br /></button></p>
                    <div className="alert alert-success">...and they will match the colors of their parent&nbsp;<Icon name="home" /></div>
                    <label>Parameters:</label>
                    <div className="param"><span className="param-name">name</span><span className="param-type">[string]</span><span className="param-desc">The reference name used by font-awesome</span></div>
                </div>
                <hr />
                <h4>Misc</h4><br />
                <Icon name="coffee" /> - Everyday must start with this<br />
                <Icon name="filter" /> - Filter icon<br />
                <Icon name="arrows-h" /> - Switch subscription<br />
                <Icon name="search" /> - Search<br />
                <Icon name="info" /> - Info icon<br />
                <Icon name="info-circle" /> - Info circle<br />
                <Icon name="share-square" /> - View all Tasks<br />
                <Icon name="eye" /> - Eye<br />
                <Icon name="sync-alt" /> - Quick update<br />
                <Icon name="cog" /> - Settings<br />
                <Icon name="tasks" /> - Tasks<br />
                <Icon name="envelope" /> - Email<br />
                <Icon name="retweet" /> - Re-open<br />
                <Icon name="times" /> - Close<br />
                <Icon name="times-circle" /> - Close/Inactive<br />
                <br />
                <h4>Task Options</h4><br />
                <Icon name="clipboard" /> - Clipboard<br />
                <Icon name="list" /> - List<br />
                <Icon name="list-ul" /> - List ul<br />
                <Icon name="list-ol" /> - List ol<br />
                <Icon name="list-alt" /> - CList alt<br />
                <Icon name="calendar-check-o" /> - Calendar check<br />
                <br />
                <h4>Delete Options</h4><br />
                <Icon name="ban" /> - Ban<br />
                <Icon name="minus-circle" /> - Minus circle<br />
                <Icon name="minus-square" /> - Minus square<br />
                <Icon name="trash-alt" /> - Trash<br />
                <Icon name="trash-o" /> - Trash alt<br />
                <br />
                <h4>Download Options</h4><br />
                <Icon name="download" /> - Download<br />
                <Icon name="cloud-download-alt" /> - Cloud download alt<br />
                <Icon name="arrow-circle-down" /> - Arrow circle down<br />
                <Icon name="arrow-circle-o-down" /> - Arrow alt circle down<br />
                <br />
                <h4>User Options</h4><br />
                <Icon name="user" /> - User icon<br />
                <Icon name="user-circle" /> - User circle<br />
                <Icon name="sign-in" /> - Sign in<br />
                <Icon name="sign-out-alt" /> - Sign out<br />
                <br />
                <h4>Calendar Options</h4><br />
                <Icon name="calendar-alt" /> - Calendar<br />
                <Icon name="calendar-check-o" /> - Calendar check<br />
                <Icon name="calendar-times-o" /> - Calendar times<br />
                <Icon name="calendar-plus-o" /> - Calendar plus<br />
                <br />
                <h4>Plus Options</h4><br />
                <Icon name="plus" /> - Plus<br />
                <Icon name="plus-circle" /> - Plus circle<br />
                <Icon name="plus-square" /> - Plus square<br />
                <br />
                <h4>File and Folders Options</h4><br />
                <Icon name="file-pdf-o" /> - File PDF<br />
                <Icon name="file-text" /> - File alt<br />
                <Icon name="file" /> - File<br />
                <Icon name="folder" /> - Folder<br />
                <Icon name="folder-open" /> - Folder open<br />
                <Icon name="edit" /> - Edit<br />
                <Icon name="pencil-alt" /> - Pencil<br />
                <Icon name="pencil-square" /> - Pen square<br />
                <br />
                <h4>Up/Collapse Options</h4><br />
                <Icon name="chevron-circle-up" /> - Chevron circle up<br />
                <Icon name="caret-square-o-up" /> - Caret square up<br />
                <Icon name="arrow-circle-up" /> - Arrow circle up<br />
                <Icon name="arrow-circle-o-up" /> - Arrow alt circle up<br />
                <br />
                <h4>Down/Expand Options</h4><br />
                <Icon name="chevron-circle-down" /> - Chevron circle down<br />
                <Icon name="caret-square-o-down" /> - Caret square down<br />
                <Icon name="arrow-circle-down" /> - Arrow circle down<br />
                <Icon name="arrow-circle-o-down" /> - Arrow alt circle down<br />
                <br />
                <h4>Down/Expand Options</h4><br />
                <Icon name="sort" /> - Sort<br />
                <Icon name="sort-asc" /> - Sort up<br />
                <Icon name="sort-desc" /> - Sort up<br />
                <Icon name="sort-amount-desc" /> - Sort down<br />
                <Icon name="sort-amount-asc" /> - Sort down<br />
                <Icon name="sort-alpha-asc" /> - Sort down<br />
                <Icon name="sort-alpha-desc" /> - Sort down<br />
            </div>
        );
    }
}
